// Declared the screenSizes and imageWidth referred from figma for better handling of UI screen sizes

const preferredScreenSizes = {
  mobile: 370,
  mobile_large: 768,
  tablet_small: 992,
  tablet_medium: 1030,
  tablet_large: 1280,
  desktop_small: 1024,
  desktop: 1440,
  desktop_xl: 1920,
};

export const imageWidth = {
  mobile: 343,
  mobile_large: 735,
  tablet_small: 472,
  tablet_large: 634,
  desktop: 740,
  desktop_xl: 740,
};

export const { mobile, mobile_large, tablet_small, tablet_large, desktop_small, desktop, desktop_xl, tablet_medium } =
  preferredScreenSizes;
